import { render, staticRenderFns } from "./TreinamentosChatBooster.vue?vue&type=template&id=0c0a0740&"
import script from "./TreinamentosChatBooster.vue?vue&type=script&lang=js&"
export * from "./TreinamentosChatBooster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports